export default {
  model: {
    prop: 'href',
    event: 'change'
  },
  props: {
    href: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('change', '');
    }
  }
};
